module.exports = __webpack_public_path__ + "img/2_10_1.c55099d3.jpg";